angular.module('picmonicng').factory('SafetyModeModal', [
  '$modal',
  'UserService',
  'MarketOptionsConfig',
  function ($modal, UserService) {
    return {
      check: function (picmonic) {
        if (UserService.seen('safety-mode-modal')) {
          return false;
        }

        return picmonic.is_mature && UserService.user && UserService.user.safety_mode;
      },
      show: function () {
        return $modal.open({
          templateUrl: '/templates/app/factories/safety-mode-modal/safety-mode-modal.html',
          windowClass: 'safety-mode-modal below-nav',
          backdropClass: 'below-nav',
          controller: [
            '$rootScope',
            '$scope',
            'UserService',
            'toaster',
            function ($rootScope, $scope, UserService, toaster) {
              $scope.UserService = UserService;

              $scope.updateSettings = function () {
                UserService.user.$update().then(function () {
                  toaster.success('', 'Your settings have been updated.');
                  $rootScope.$broadcast('safetyModeToggle');
                });
              };

              $scope.close = function () {
                $scope.$close();
              };
            },
          ],
        });
      },
    };
  },
]);
